/** Renders a step's save error — a bulleted list for every STEP_INCOMPLETE message when there's more than one, or a plain line for a single string. */
export function StepErrorList({ error }: { error: string | string[] }) {
  if (!Array.isArray(error)) return <span>{error}</span>;
  return (
    <ul className="list-disc space-y-0.5 pl-4">
      {error.map((msg, i) => (
        <li key={i}>{msg}</li>
      ))}
    </ul>
  );
}
